import Box from '@mui/material/Box/Box'
import Link from '@mui/material/Link/Link'
import Paper from '@mui/material/Paper/Paper'
import Stack from '@mui/material/Stack/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import { isHTML } from '../shared/common'
import { Spacer } from '../spacer/spacer'

export type TCardEntry = {
  displayName?: string | null
  content?: string | string[] | null
  description?: string | null
  type?: string
} & Record<string, unknown>

export const FlexCardDisplay = ({ cardData }: { cardData: TCardEntry[] }) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Paper sx={{ p: 2, borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
      <Stack spacing={2}>
        {cardData.map(({ displayName, content, type, description }, index) => (
          <Box key={index}>
            <Typography variant={index === 0 ? 'h5' : 'h6'}>{displayName}</Typography>
            {renderContent(content, type, description)}
            {index === 0 && <Spacer height={2} />}
          </Box>
        ))}
      </Stack>
    </Paper>
  )
}

function renderContent(content?: string | string[] | null, type?: string, description?: string | null) {
  if ((typeof content === 'string' && !content?.trim()) || !content?.length) {
    return null
  }

  switch (type) {
    case 'URL': {
      return (
        <Link href={content as string} target="_blank">
          {description || content || ''}
        </Link>
      )
    }
    default: {
      if (typeof content === 'string') {
        return (
          <Typography variant="body1" data-testid="flex-content">
            {content}
          </Typography>
        )
      }
      return (
        <Box data-testid="flex-content" mt={-2}>
          {content.map((row, idx) =>
            isHTML(row) ? (
              <div key={idx} dangerouslySetInnerHTML={{ __html: row }} />
            ) : (
              <Typography key={idx} variant="body1">
                {row}
              </Typography>
            )
          )}
        </Box>
      )
    }
  }
}
